document.addEventListener("DOMContentLoaded", async function () {

  const blob_url = Shopify.swyft.collectionJson;
  let locale = Shopify.locale.toLowerCase();
  let location = Shopify.country.toLowerCase();
  let location_locale = `${location}-${locale}`;

  if (Shopify.customer != null) {
  if (Shopify.customer.b2b) {
    location_locale = 'green-green';
  } 
  if (Shopify.customer.company.id == '16656204111') {
    location_locale = 'homebound-homebound';
  } else if (Shopify.customer.company.id == '16789274959') {
    location_locale = 'uneeka-uneeka';
  } else if (Shopify.customer.tags && Shopify.customer.tags.includes("retail_partners")) {
    location_locale = 'retail_partners-retail_partners';
  }
}

const cacheBuster = Math.floor(Math.random() * 1000000); 
  const request_url = `${blob_url}${location_locale}/${window.collection_id}.json?cb=${cacheBuster}`;
  
  try {
  
    const response = await fetch(`${request_url}`);
    const data = await response.json();

    window.swyft_collection = data.products || [];
    const event = new CustomEvent("swyftCollectionLoaded");
    window.dispatchEvent(event);
  } catch (error) {
    console.error("Error fetching collection products:", error);
  }
});